var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortByDateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "calendar_today"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2441_3092",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2441_3092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendar_today_2",
    d: "M4.75577 17.5833C4.38065 17.5833 4.06358 17.4514 3.80456 17.1875C3.54553 16.9236 3.41602 16.609 3.41602 16.2436V5.75645C3.41602 5.39106 3.54553 5.07642 3.80456 4.81254C4.06358 4.54865 4.38065 4.4167 4.75577 4.4167H6.57629V2.32056H7.69164V4.4167H12.3391V2.32056H13.4224V4.4167H15.2429C15.618 4.4167 15.9351 4.54865 16.1941 4.81254C16.4531 5.07642 16.5826 5.39106 16.5826 5.75645V16.2436C16.5826 16.609 16.4531 16.9236 16.1941 17.1875C15.9351 17.4514 15.618 17.5833 15.2429 17.5833H4.75577ZM4.75577 16.5H15.2429C15.307 16.5 15.3658 16.4733 15.4192 16.4199C15.4726 16.3665 15.4993 16.3077 15.4993 16.2436V9.25645H4.49933V16.2436C4.49933 16.3077 4.52604 16.3665 4.57945 16.4199C4.63288 16.4733 4.69165 16.5 4.75577 16.5ZM4.49933 8.17314H15.4993V5.75645C15.4993 5.69234 15.4726 5.63357 15.4192 5.58014C15.3658 5.52672 15.307 5.50002 15.2429 5.50002H4.75577C4.69165 5.50002 4.63288 5.52672 4.57945 5.58014C4.52604 5.63357 4.49933 5.69234 4.49933 5.75645V8.17314Z",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortByDateIcon);
export default __webpack_public_path__ + "static/media/SortByDateIcon.042283171f244fb2ca722a0cdfee4fc4.svg";
export { ForwardRef as ReactComponent };